import React from 'react';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { ImageType } from '@types';
import Checkbox from '@components/Checkbox';
import Image from '@components/Image';
import { $audioPlayer } from '@stores/audioPlayerStores';
import { getDemoUrl, type TTSConfigItem } from './ttsConfig';
import { TTSAvatar } from './TTSAvatar';

type Props = {
  data: TTSConfigItem;
  isSelected: boolean;
  disabled?: boolean;
  onClick: (data: TTSConfigItem) => void;
};

export const TTSItem = React.memo(
  ({ data, isSelected, disabled, onClick }: Props) => {
    const { name, isVip, avatar, voiceId } = data;
    const url = getDemoUrl(voiceId);
    const isPlaying = useStore($audioPlayer.$playingAudio) === url;
    const handleClick = () => {
      if (isSelected || disabled) return;
      onClick(data);
    };
    return (
      <div
        className={classNames(
          'flex h-50 items-center border-b px-20 hover:bg-white-light',
          {
            'cursor-pointer': !disabled,
          }
        )}
        onClick={handleClick}
      >
        <Checkbox checked={isSelected} onClick={handleClick} />
        <TTSAvatar type={avatar} className="ml-20" />
        <div className="ml-10">{name}</div>
        {isVip && (
          <Image
            src="/imgs/vip.a0f6972a1cf28d75c18bf2eea22b7138.png"
            type={ImageType.sysMedia}
            className="ml-10 h-16 w-16"
          />
        )}
        <Image
          src={
            isPlaying
              ? '/imgs/tts-pause.7a720cb8a75fc1ae590910cec528ff02.png'
              : '/imgs/tts-play.08be31e5ce1055882addf0ab2fc4564d.png'
          }
          type={ImageType.sysMedia}
          className="ml-auto h-16 w-16 cursor-pointer"
          onClick={(e) => {
            if (disabled) return;
            e.stopPropagation();
            $audioPlayer.playAudio(url, { loop: false });
          }}
        />
      </div>
    );
  }
);
